export default __webpack_public_path__ + "static/media/serviceImage4.321ce3d2.jpg";